import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/pages/home.vue'
import Shop from '@/pages/shop.vue'
import Login from '@/pages/login.vue'

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true },
    redirect: '/admin/dashboard',
    // meta.title feeds the topbar breadcrumb.
    children: [
      { path: 'dashboard', name: 'admin-dashboard', meta: { title: 'Ülevaade' },
        component: () => import('@/pages/admin/dashboard/index.vue') },
      { path: 'products', name: 'admin-products', meta: { title: 'Tooted' },
        component: () => import('@/pages/admin/product/list.vue') },
      { path: 'products/:id', name: 'admin-product-edit', meta: { title: 'Toote muutmine' },
        component: () => import('@/pages/admin/product/edit.vue') },
      { path: 'product-imports', name: 'admin-product-imports', meta: { title: 'Impordid' },
        component: () => import('@/pages/admin/product-import/list.vue') },
      { path: 'product-imports/:id', name: 'admin-product-import-edit', meta: { title: 'Impordi ülevaatus' },
        component: () => import('@/pages/admin/product-import/edit.vue') },
      { path: 'import-requests', name: 'admin-import-requests', meta: { title: 'Impordisoovid' },
        component: () => import('@/pages/admin/import-request/list.vue') },
      { path: 'categories', name: 'admin-categories', meta: { title: 'Kategooriad' },
        component: () => import('@/pages/admin/category/list.vue') },
      { path: 'brands', name: 'admin-brands', meta: { title: 'Tootjad' },
        component: () => import('@/pages/admin/brand/list.vue') },
      { path: 'specs', name: 'admin-specs', meta: { title: 'Spetsifikatsioonid' },
        component: () => import('@/pages/admin/spec/list.vue') },
      { path: 'energy-labels', name: 'admin-energy-labels', meta: { title: 'Energiamärgised' },
        component: () => import('@/pages/admin/energy-label/list.vue') },
      { path: 'services', name: 'admin-services', meta: { title: 'Teenused' },
        component: () => import('@/pages/admin/service/list.vue') },
      { path: 'contacts', name: 'admin-contacts', meta: { title: 'Kontaktitaotlused' },
        component: () => import('@/pages/admin/contact/list.vue') },
      { path: 'product-requests', name: 'admin-product-requests', meta: { title: 'Tootepäringud' },
        component: () => import('@/pages/admin/product-request/list.vue') },
      { path: 'product-requests/:id', name: 'admin-product-request-edit', meta: { title: 'Päringu muutmine' },
        component: () => import('@/pages/admin/product-request/edit.vue') },
      { path: 'tasks', name: 'admin-tasks', meta: { title: 'Ülesanded' },
        component: () => import('@/pages/admin/task/list.vue') },
      { path: 'readings', name: 'admin-readings', meta: { title: 'Kuunäidud' },
        component: () => import('@/pages/admin/readings/list.vue') },
      { path: 'meter-types', name: 'admin-meter-types', meta: { title: 'Arvesti tüübid' },
        component: () => import('@/pages/admin/readings/types.vue') },
      { path: 'readings/:id', name: 'admin-readings-building', meta: { title: 'Kuunäidud' },
        component: () => import('@/pages/admin/readings/building.vue') },
      { path: 'devices', name: 'admin-devices', meta: { title: 'Seadmed' },
        component: () => import('@/pages/admin/device/list.vue') },
      { path: 'test', name: 'admin-test', meta: { title: 'Vormide test' },
        component: () => import('@/pages/admin/test/index.vue') },
    ],
  },
  {
    path: '/pood',
    component: Shop,
    children: [
      {
        path: '',
        name: 'shop',
        component: () => import('@/pages/shop/grid.vue'),
      },
      {
        path: ':category',
        name: 'shop-category',
        component: () => import('@/pages/shop/grid.vue'),
      },
      {
        path: ':category/:productId',
        name: 'product',
        component: () => import('@/pages/shop/detail.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: Login,
  },
  {
    // Public on purpose: the form editor works entirely in the browser on the
    // bundled .frf asset, so there is nothing behind it to protect.
    path: '/arve',
    name: 'arve-form',
    component: () => import('@/pages/arve.vue'),
  },
  {
    // Public: the ?client= token is the client's only credential.
    path: '/naidud',
    name: 'naidud',
    component: () => import('@/pages/naidud.vue'),
  },
  {
    // The page was /vesi until 2026-10; links already sent to clients carry it.
    path: '/vesi',
    redirect: to => ({ path: '/naidud', query: to.query }),
  },
  {
    path: '/elekter',
    name: 'elekter',
    component: () => import('@/pages/elekter.vue'),
  },
  {
    path: '/tracking/:hash',
    name: 'tracking',
    component: () => import('@/pages/tracking.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to) => {
  if (to.meta.requiresAuth && !localStorage.getItem('token')) {
    return '/login'
  }
})

export default router
